import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import * as tilesStyles from "./Tiles.module.css";

const Tile = ({ props, aosOffset }) => {
  const { title, image, destination, eyebrow } = props;

  const imageFile = image && getImage(image.file);
  return (
    <Link
      to={destination}
      className={tilesStyles.tile}
      // data-aos="fade-up"
      // data-aos-offset={aosOffset}
    >
      <div>
        {eyebrow && <small>{eyebrow}</small>}
        {title && <h5 className={tilesStyles.title}>{title}</h5>}
      </div>
      {image && (
        <div className={tilesStyles.imageBg}>
          <GatsbyImage image={imageFile} alt={image.alt} />
        </div>
      )}
    </Link>
  );
};

const Tiles = ({ props }) => {
  const { tiles, variant, background } = props;

  return (
    <div
      className={`${tilesStyles.tiles} ${tilesStyles[variant]} ${tilesStyles[background]}`}
    >
      <div className={tilesStyles.tileContainer}>
        {tiles.map((tile, index) => (
          <Tile
            key={index}
            props={tile}
            // aosOffset={(index + 1) * 25}
          />
        ))}
      </div>
    </div>
  );
};

export default Tiles;
